function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.25021 6.50012C2.70956 6.49319 2.20699 6.77767 1.93467 7.24477C1.66236 7.71188 1.6624 8.28938 1.9348 8.75644C2.2072 9.22351 2.70981 9.5079 3.25046 9.50087C4.07154 9.49021 4.73154 8.82153 4.73147 8.00038C4.7314 7.17923 4.07129 6.51065 3.25021 6.50012ZM12.7502 6.50012C11.9291 6.51072 11.2691 7.17935 11.2691 8.0005C11.2691 8.82165 11.9291 9.49027 12.7502 9.50087C13.5713 9.49027 14.2313 8.82165 14.2313 8.0005C14.2313 7.17935 13.5713 6.51072 12.7502 6.50012ZM8.00021 6.50012C7.45956 6.49319 6.95699 6.77767 6.68467 7.24477C6.41235 7.71188 6.4124 8.28938 6.6848 8.75644C6.9572 9.22351 7.45981 9.5079 8.00046 9.50087C8.82154 9.49021 9.48154 8.82153 9.48147 8.00038C9.4814 7.17923 8.82129 6.51065 8.00021 6.50012Z"
});
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#111827",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.95de81bf838b78359d5f57f3e455b9d9.svg";
export { ForwardRef as ReactComponent };